<template lang="pug">
  div
    challenge-relationship-modal(v-if="showChallengeRelationshipModal" :action="showChallengeRelationshipModal")
    challenge-relationship-details-modal(
      v-if="showChallengeRelationshipDetailsModal"
      :action="showChallengeRelationshipDetailsModal")
    challenge-expiration-modal(v-if="showChallengeExpirationModal")
    challenge-address-modal(v-if="showChallengeAddressModal")
    challenge-periods-modal(v-if="showChallengePeriodsModal")
    challenge-lei-code-modal(v-if="showChallengeLeiCodeModal")
    challenge-modal(v-if="showChallengeModal")
    relationship-modal(v-if="showRelationshipData")
    full-data-modal(v-if="showFullData")
    modification-modal(v-if="showModificationsModal")
    changes-modal(v-if="showChangesModal")
    lei-issuer-modal
    challenge-summary-modal
    login-modal(v-if="showAuthModal" :action="showAuthModal")
</template>
<script>
import { mapState, } from 'vuex'
import LeiIssuerModal from '../modals/LeiIssuerModal'
import ChallengeModal from '../modals/ChallengeModal'
import ChallengeAddressModal from '../modals/ChallengeAddressModal'
import ChallengePeriodsModal from '../modals/ChallengePeriodsModal'
import ChallengeLeiCodeModal from '@/components/modals/ChallengeLeiCodeModal'
import ChallengeSummaryModal from '@/components/modals/ChallengeSummaryModal'
import ChallengeExpirationModal from '@/components/modals/ChallengeExpirationModal'
import LoginModal from '@/components/modals/LoginModal'
import RelationshipModal from '@/components/modals/RelationshipModal'
import FullDataModal from '@/components/modals/FullDataModal'
import ModificationModal from '@/components/modals/ModificationModal'
import ChangesModal from '@/components/modals/ChangesModal'
import ChallengeRelationshipDetailsModal from '@/components/modals/ChallengeRelationshipDetailsModal'
import ChallengeRelationshipModal from '@/components/modals/ChallengeRelationshipModal'


export default {
  components: {
    ChallengeRelationshipDetailsModal,
    RelationshipModal,
    LoginModal,
    LeiIssuerModal,
    ChallengeExpirationModal,
    ChallengeSummaryModal,
    ChallengeLeiCodeModal,
    ChallengeAddressModal,
    ChallengePeriodsModal,
    ChallengeModal,
    FullDataModal,
    ModificationModal,
    ChangesModal,
    ChallengeRelationshipModal,
  },
  computed: {
    ...mapState('record/challenge', [
      'showChallengeModal',
      'showChallengeAddressModal',
      'showChallengeRelationshipModal',
      'showChallengeRelationshipDetailsModal',
      'showChallengeLeiCodeModal',
      'showChallengeExpirationModal',
      'showChallengePeriodsModal',
    ]),
    ...mapState('record', [
      'showRelationshipData',
      'showFullData',
      'showModificationsModal',
      'showChangesModal',
    ]),
    ...mapState('auth', [ 'showAuthModal', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

</style>



// WEBPACK FOOTER //
// src/components/record-details/RecordModals.vue